import './tableContent.css';

const TableContent = ({ data }) => {
    return (
        <table className='tableContent'>
            <tbody>
                {data.map((item, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.label}</td>
                        <td style={{ whiteSpace: 'pre-line' }}>{item.answer}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableContent;
